import { __assign, __rest } from "tslib";
import React from 'react';
import { PnmacImage, PnmacNavigation, HomeCard } from 'pnmac-universal-components';
import { getActiveFeatures } from '../../utils';
import { trackEvent } from '../../Tealium';
import { TrackerCategoryLID_ENUM, TrackerHitTypeLID_ENUM, UserLanguage_ENUM } from '../../redux/events/events';
import EdibursmentsSVG from '../../assets/e-disbursements.svg';
import AmortizationSVG from '../../assets/amortization.svg';
import AutoPaySVG from '../../assets/autoPay.svg';
export var AmortizationCardPicker = function (_a) {
  var _b, _c, _d;
  var matches = _a.matches,
    enabled = _a.enabled,
    props = __rest(_a, ["matches", "enabled"]);
  var layout = props.layout,
    translations = props.translations,
    trackerDispatcher = props.trackerDispatcher;
  var achExist = (_c = (_b = layout === null || layout === void 0 ? void 0 : layout.paymentModel) === null || _b === void 0 ? void 0 : _b.pendingPayments) === null || _c === void 0 ? void 0 : _c.find(function (s) {
    return s.paymentType == 201309;
  });
  var isCESLoan = ((_d = layout === null || layout === void 0 ? void 0 : layout.currentLoan) === null || _d === void 0 ? void 0 : _d.lienPriorityType) == 2;
  var shouldRenderAmortSchedule = layout.banksToAdd && layout.banksToAdd.length > 0 && layout.banksToAdd.find(function (s) {
    return s.isEDisbursementAccount;
  });
  var iconSize = matches.small ? 40 : 65;
  if (!shouldRenderAmortSchedule && getActiveFeatures(layout.features, "View_Edisbursments")) {
    if (isCESLoan && !achExist) {
      return /*#__PURE__*/React.createElement(HomeCard, {
        nativeID: "AutoPayTile",
        title: translations === null || translations === void 0 ? void 0 : translations.CESAutoPayTitle,
        icon: function () {
          return PnmacImage(layout.mobile ? 'autoPay' : AutoPaySVG, iconSize, 'Dollar sign', 'css');
        },
        body: translations === null || translations === void 0 ? void 0 : translations.CESAutoPayMessage,
        buttonText: translations === null || translations === void 0 ? void 0 : translations.EnrollNow,
        buttonDisabled: !enabled || layout.pennyWise,
        small: matches.small,
        mobile: layout.mobile,
        onButtonPress: function () {
          trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Page, TrackerHitTypeLID_ENUM.PageView, TrackerHitTypeLID_ENUM.PageView, 'CES Pennyhome Page: Enroll Now Link Clicked', 0);
          PnmacNavigation(__assign({
            action: {
              pathname: "/Payment/Ach"
            }
          }, props));
        }
      });
    } else {
      return /*#__PURE__*/React.createElement(HomeCard, {
        nativeID: "RefundsTile",
        title: translations === null || translations === void 0 ? void 0 : translations.Refunds,
        icon: function () {
          return PnmacImage(layout.mobile ? 'eDisbursements' : EdibursmentsSVG, iconSize, 'Dollar sign', 'css');
        },
        body: translations.eDisbMessage,
        buttonText: translations === null || translations === void 0 ? void 0 : translations.Enroll,
        buttonDisabled: !enabled || layout.pennyWise,
        small: matches.small,
        mobile: layout.mobile,
        onButtonPress: function () {
          trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Page, TrackerHitTypeLID_ENUM.PageView, TrackerHitTypeLID_ENUM.PageView, 'Refunds Button Clicked', 0);
          if (layout.mobile) {
            if (getActiveFeatures(layout.features, "Native_Account_Settings", layout.whitelisted)) {
              PnmacNavigation(__assign({
                action: {
                  pathname: "/Account"
                }
              }, props));
            } else {
              PnmacNavigation(__assign({
                action: "".concat(layout.pennyHomeUrl, "Account/eDisbursement?ids_token=").concat(layout.token),
                wind: true,
                target: '_blank'
              }, props));
            }
          } else {
            PnmacNavigation(__assign({
              action: {
                pathname: "/Account/eDisbursement"
              }
            }, props));
          }
        }
      });
    }
  }
  // Default
  return /*#__PURE__*/React.createElement(HomeCard, {
    nativeID: "AmortSceduleTile",
    title: translations === null || translations === void 0 ? void 0 : translations.AmortizationSchedule,
    icon: function () {
      return PnmacImage(layout.mobile ? 'amortization' : AmortizationSVG, iconSize, 'Question mark icon', 'css', 30);
    },
    body: translations === null || translations === void 0 ? void 0 : translations.AmortScheduleMessage,
    buttonText: translations === null || translations === void 0 ? void 0 : translations.AmortizationSchedule,
    buttonDisabled: !enabled,
    small: matches.small,
    mobile: layout.mobile,
    onButtonPress: function () {
      trackEvent('calculator_engagement');
      trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Page, TrackerHitTypeLID_ENUM.PageView, TrackerHitTypeLID_ENUM.PageView, 'Amortization Schedule Button Clicked', 5);
      if (layout.mobile) {
        PnmacNavigation(__assign({
          action: "".concat(layout.pennyHomeUrl, "/AmortizationCalculator?ids_token=").concat(layout.token),
          wind: true,
          target: '_blank'
        }, props));
      } else {
        PnmacNavigation(__assign({
          action: {
            pathname: "/AmortizationCalculator"
          }
        }, props));
      }
    }
  });
};